import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function clientPracticeMessagesMarkAllAsSeenApi(path: string) {
  return {
    path,
    PATCH: () => api.patch<JsonApiResponse>(path),
  };
}
